import { Component, Input, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { UserRightsService } from '../../base-services/user-rights.service';

@Component({
  selector: 'yt-button',
  templateUrl: './button.component.html'
})
export class ButtonComponent implements OnInit {

  constructor(
    protected userRightsService: UserRightsService
  ) {
    
   }

  private userRightValue: boolean = false;
  private _isDisabled: boolean = false;
  isDisabled: boolean;

  @Input() IsHidden: boolean = false;
  @Input() set IsDisabled(value : boolean){
    this._isDisabled = value;
    this.checkIsDisabled();
  } 
  
  @Input() Class: string;
  @Input() NgbTooltip : string;
  @Input() Placement: string = 'top';
  @Input() Container: string = 'body';
  @Input() NgStyle: string;

  @Input() Model: string;
  @Input() Action: string;

  @Output() clicked = new EventEmitter();

  translateNgbToolTip: string; 
  ngOnInit() {    
    this.userRightValue = this.userRightsService.GetUserRightValue(this.Model, this.Action);
    this.checkIsDisabled();
  }

  onClick(value){
    this.clicked.emit(value);
  }

  checkIsDisabled(){
    this.isDisabled = this.userRightValue == false ? true : this._isDisabled;

  }
}
